import './set-iframe-height'

(() => {
  window.nextEegCalculator = window.nextEegCalculator || {}
  window.nextEegCalculator.load = function () {
    const container = document.querySelector('#next-eeg-rechner-container')
    container.setAttribute('status', 'initialized')

    const iframe = window.document.createElement('iframe')
    iframe.src = 'javascript:void(0)'
    iframe.title = ''
    iframe.role = 'presentation'
    iframe.style = 'border: none; width: 100%;'
    iframe.id = 'next-eeg-rechner-app-iframe'

    container.appendChild(iframe)

    const iframeDocument = iframe.contentWindow.document
    window.nextEegCalculator.document = iframeDocument

    iframeDocument.open()
    iframeDocument.setup = async () => {
      try {
        const res = await fetch('https://eegrechner-cae5bbamaaeebder.a03.azurefd.net')
        const html = await res.text()

        iframeDocument.documentElement.innerHTML = ''
        iframeDocument.documentElement.innerHTML = html

        iframeDocument.querySelectorAll('script').forEach(function (script) {
          const newScript = iframeDocument.createElement('script')
          newScript.src = script.src
          iframeDocument.querySelector('head').appendChild(newScript)
        })

        container.setAttribute('status', 'loaded')
      } catch (exception) {
        console.error(exception)
      }
    }

    const html = iframeDocument.createElement('html')
    iframeDocument.appendChild(html)
    iframeDocument.close()

    iframeDocument.setup()
    container.setAttribute('status', 'created')
  }

  window.nextEegCalculator.load()

  // Safari Fix
  window.nextEegCalculator.document.querySelectorAll('html').forEach((element, i) => {
    if (i === 0) {
      return
    }

    element.remove()
  })
})()
